export const SeoDetailsData = [
  {
    icon:"bi:stars",
    title:'LEAD GENERATION',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"ph:tree-view-fill" ,
    title:'E-COMMERCE',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"iconoir:message-text",
    title:'SEM',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"system-uicons:clipboard-notes" ,
    title:'EMAIL MARKETING',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"iconamoon:search-duotone",
    title:'PPC',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"jam:screen-f",
    title:'GDM',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },

]